import React, { Component } from 'react'

import { trackLabel } from '../../stores'

export default class extends Component {
  componentDidMount () {
    if (!this.props.formData) {
      const experience = this.props.formContext.experience
      this.props.onChange(experience.authorizations.tracks[0])
    }
  }

  render () {
    const experience = this.props.formContext.experience
    return (
      <div className='form-group field field-string'>
        <label className='control-label' htmlFor={this.props.name}>
          {this.props.schema.title}
        </label>
        <select
          className='form-control'
          value={this.props.formData}
          onChange={e => this.props.onChange(e.target.value)}
        >
          <option />
          {experience.authorizations.tracks
            .sort((t1, t2) =>
              (trackLabel[t1] || t1).localeCompare(trackLabel[t2] || t2)
            )
            .map(m => {
              return (
                <option value={m} key={m}>
                  {trackLabel[m] || m}{' '}
                </option>
              )
            })}
        </select>
      </div>
    )
  }
}
